import PricePlanService from '../../service/pricePlan';

const Action = {
    GET_PRICE_PLAN: "GET_PRICE_PLAN",
    GET_PRICE_PLANS: "GET_PRICE_PLANS",
};

const ActionCreator = {
    getPricePlans() {
        return async (dispatch) => {
            try {
                const pricePlans = await PricePlanService.list();
                dispatch({type: Action.GET_PRICE_PLANS, pricePlans});
                return pricePlans;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
};

const initialState = {
    list: [],
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_PRICE_PLAN:
            return {
                ...state,
                ...action.pricePlan
            };
        case Action.GET_PRICE_PLANS:
            return {
                ...state,
                list: action.pricePlans
            };
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/pricePlan.js